import type { CrucibleRecipeSummary, CrucibleTemplate } from '@sorrem/shared';
import { useGetCrucibleRecipesQuery, useGetCrucibleTemplatesQuery } from '@sorrem-client/ui/store';

export interface CreateCrucibleOptions {
    /** Sizes of random crucible, smallest first (#223). */
    readonly recipes: readonly CrucibleRecipeSummary[];
    /** Hand-made crucibles with a fixed map. */
    readonly authoredTemplates: readonly CrucibleTemplate[];
    readonly isLoading: boolean;
}

const NO_RECIPES: readonly CrucibleRecipeSummary[] = [];
const NO_TEMPLATES: readonly CrucibleTemplate[] = [];

/** What the Create Crucible form offers: random sizes and authored crucibles (#223). */
export function useCreateCrucibleOptions(): CreateCrucibleOptions {
    const recipes = useGetCrucibleRecipesQuery();
    const templates = useGetCrucibleTemplatesQuery();
    return {
        recipes: recipes.data ?? NO_RECIPES,
        authoredTemplates: templates.data ?? NO_TEMPLATES,
        isLoading: recipes.isLoading || templates.isLoading,
    };
}
